module.exports = __webpack_public_path__ + "img/Upscaler03.42baaa89.png";